import { Image } from '~/components/Image';
import type { Publication } from '~/interfaces/publication';

import Typography from '../Typography';

interface Props {
  publication: Publication;
}

const PublicationHeading = ({ publication }: Props) => {
  const textOnBackgroundColor = publication.web_theme.text_on_background_color;
  return (
    <div className="flex w-full flex-col items-center">
      <div className={'mb-4 h-24 w-24 overflow-hidden rounded shadow-md sm:mb-8'}>
        {publication.logo.thumb.url && (
          <Image src={publication.logo.thumb.url} alt={publication.name} maxWidth={200} aspectRatio="square" />
        )}
      </div>
      <div className="mb-6 flex flex-col items-center space-y-2.5 sm:space-y-3">
        {publication.name && (
          <Typography
            as="h1"
            size="5xl"
            color={textOnBackgroundColor}
            className="w-full break-words text-center leading-tight tracking-normal"
          >
            {publication.name}
          </Typography>
        )}
        {publication.description && (
          <Typography
            as="p"
            color={textOnBackgroundColor}
            className="text-md text-center tracking-wide opacity-75 sm:text-lg"
          >
            {publication.description}
          </Typography>
        )}
      </div>
    </div>
  );
};

export default PublicationHeading;
